import { createListenerMiddleware } from '@reduxjs/toolkit'

import {
  authenticationLogout,
  authenticationVerifyOnboarding
} from '../../actions/authentication-actions'
import api from '../../api'
import { hasCurrentUserCompletedOnboardingSelector } from '../../slices/authentication-slice'
import type { IdentityRootState } from '../../types/state'

const authenticationVerifyOnboardingListener = createListenerMiddleware<IdentityRootState>()

authenticationVerifyOnboardingListener.startListening({
  actionCreator: authenticationVerifyOnboarding,
  async effect(_, { dispatch, getState }) {
    const { data: currentUser, isError } = await dispatch(
      api.endpoints.getCurrentUser.initiate(undefined, { forceRefetch: true })
    )

    if (isError || !currentUser) {
      dispatch(authenticationLogout({}))

      return
    }

    const hasCurrentUserCompletedOnboarding = hasCurrentUserCompletedOnboardingSelector(getState())

    if (hasCurrentUserCompletedOnboarding) {
      window.location.reload()
    }
  }
})

export default authenticationVerifyOnboardingListener
